import { render, staticRenderFns } from "./dashboards.vue?vue&type=template&id=bac7c116&scoped=true&"
import script from "./dashboards.vue?vue&type=script&lang=js&"
export * from "./dashboards.vue?vue&type=script&lang=js&"
import style0 from "./../assets/style.css?vue&type=style&index=0&id=bac7c116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac7c116",
  null
  
)

export default component.exports